/**
 * Novo template de e-mail. O gatilho é escolhido numa lista (sem risco
 * de digitação): só os 3 gatilhos que o servidor dispara, com os já
 * usados bloqueados — o banco aceita um único template por gatilho e a
 * digitação livre devolvia erro seco do servidor no caso repetido.
 */
import {
  CreateContextProvider,
  required,
  SaveButton,
  SelectInput,
  SimpleForm,
  TextInput,
  useCreateController,
  useGetList,
} from "react-admin";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Grid from "@mui/material/Grid";
import { RichTextInput } from "ra-input-rich-text";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { mailTriggers } from "./mail-templates-util";

export const MailTemplateCreate = (props: any) => {
  const controller: any = useCreateController({
    resource: "mail-templates/crud",
  });

  // Gatilhos já ocupados ficam visíveis porém bloqueados
  const { data: existing } = useGetList("mail-templates/crud", {
    pagination: { page: 1, perPage: 100 },
    sort: { field: "name", order: "ASC" },
  });
  const taken = new Set(
    (existing ?? []).map((t: any) => String(t.trigger)).filter(Boolean)
  );
  const triggerChoices = Object.entries(mailTriggers).map(([code, info]) => ({
    id: code,
    name: taken.has(code)
      ? `${info.label} — ${code} (já em uso)`
      : `${info.label} — ${code}`,
    disabled: taken.has(code),
  }));

  return (
    <CreateContextProvider value={controller}>
      {/* toolbar={false}: Salvar sai do rodapé e vai para o topo */}
      <SimpleForm toolbar={false}>
        <PageTopBreadcrumb
          title="Templates de E-mail"
          firstPath="/#/mail-templates/crud"
          secondTitle="Novo"
          actions={<SaveButton type="button" label="Salvar" />}
        />
        <Card sx={{ padding: 2, marginBottom: 3, width: "100%" }}>
          <CardHeader title="Novo Template de E-mail" />
          <CardContent>
            <Grid container columnSpacing={2} rowSpacing={0.5}>
              <Grid item xs={12} md={6}>
                <TextInput
                  source="name"
                  label="Nome"
                  fullWidth
                  helperText={false}
                  validate={required()}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <SelectInput
                  source="trigger"
                  label="Gatilho"
                  choices={triggerChoices}
                  fullWidth
                  validate={required()}
                  helperText="Um template por gatilho — os já usados aparecem bloqueados"
                />
              </Grid>
              <Grid item xs={12}>
                <TextInput
                  source="subject"
                  label="Assunto"
                  fullWidth
                  helperText={false}
                  validate={required()}
                />
              </Grid>
              <Grid item xs={12}>
                <div className="richTextBody">
                  <RichTextInput
                    source="body"
                    label="Corpo do e-mail"
                    fullWidth
                    helperText={false}
                    validate={required()}
                  />
                </div>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </SimpleForm>
    </CreateContextProvider>
  );
};
